import { all, fork } from 'redux-saga/effects';

import watchLandigpageRequest from './landigpageRequest';

function* landingpageSagas() {
  yield all([fork(watchLandigpageRequest)]);
}

export default landingpageSagas;
